import  { useEffect, useRef, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";

import HomePage from "../pages/home/HomePage";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
import AuthPage from "../pages/auth/AuthPage";
import { LayoutContextProvider } from "../../infofleet";
import Layout from "../../infofleet/layout/Layout";
import * as routerHelpers from "../router/RouterHelpers";
import { serverurl } from "./config";
import api from "./axiosConfig";

const AppRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const prevLocationRef = useRef(null);
  const [lastLocation, setLastLocation] = useState(null);

  useEffect(() => {
    setLastLocation(prevLocationRef.current);
    prevLocationRef.current = location;
  }, [location]);

  useEffect(() => {
    getsession();
    const intervalId = setInterval(getsession, 16 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  const getsession = () => {
    api.get(serverurl + "isSessionExist").then((response) => {
      if (response.data === false) {
        navigate("/logout");
      }
    });
  };

  // Save last location to helper
  useEffect(() => {
    if (lastLocation) {
      routerHelpers.saveLastLocation(lastLocation);
    }
  }, [lastLocation]);

  const {
    isAuthorized,
    menuConfig,
    quickoptionConfig,
    userLastLocation,
    functionaltree,
  } = useSelector(
    ({ auth, urls, builder: { menuConfig } }) => ({
      menuConfig,
      quickoptionConfig,
      functionaltree,
      isAuthorized: auth.authToken === 1,
      userLastLocation: routerHelpers.getLastLocation(),
    }),
    shallowEqual
  );

  return (
    <LayoutContextProvider
      history={{ navigate, location }}
      menuConfig={menuConfig}
      quickoptionConfig={quickoptionConfig}
      functionaltree={functionaltree}
    >
      <Routes>
        {/* Not authorized user goes to auth page */}
        {!isAuthorized ? (
          <>
            <Route path="/auth/*" element={<AuthPage />} />
            <Route path="/error/*" element={<ErrorsPage />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </>
        ) : (
          <>
            {/* <Route path="/auth/*" element={<Navigate to={userLastLocation || "/"} replace />} /> */}
            <Route path="/auth/*" element={<AuthPage />} />
            <Route path="/error/*" element={<ErrorsPage />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route
              path="/*"
              element={
                <Layout>
                  <HomePage userLastLocation={userLastLocation} auth={isAuthorized} />
                </Layout>
              }
            />
          </>
        )}
      </Routes>
    </LayoutContextProvider>
  );
};
export default AppRoutes;